import { urls } from '@zapier/identity-utils';
/* This array should contain all routes that are part of
 ** the app. Navigation to any of these routes will be
 ** handled by pushState. Otherwise, a regular <a href /> will be used.
 */
export default [
  urls.ACCOUNT_LOCKED_URL,
  urls.ACTIVATE_ACCOUNT_URL,
  urls.COOKIE_ERROR_URL,
  urls.FORGOT_PASSWORD_URL,
  urls.LOGIN_URL,
  urls.RESET_PASSWORD_URL,
  urls.SIGNUP_URL,
  urls.TWO_FACTOR_URL,
];
